import { PublicCallback } from 'globals/types';
import { handleError } from 'globals/errors';
import {
  createMessage,
  delayFetchMessageAttachments,
} from 'core_main/api/messages';
import {
  ON_CONVERSATION_ENDED_EVENT_TYPE,
  ON_MESSAGE_SENT_EVENT_TYPE,
} from 'core/constants';
import { runListenersForEvent } from 'core_main/globals/events';

import { createMessageCallbackResponse } from './helpers';
import { SendMessageParameters } from './types';
import { ConversationCallbackResponse } from '../types';

export const sendMessage = (
  parameters: SendMessageParameters,
  cb?: PublicCallback,
) => {
  const sessionId = parameters?.conversationId;
  const body = parameters?.body;
  const payload = parameters?.payload;
  const attachments = parameters?.attachments;
  const lastDeflection = parameters?.lastDeflection;
  const isInAssistantMode = parameters?.isInAssistantMode;
  const initAssistantPayload = parameters?.initAssistantPayload;
  const lang = parameters?.lang;
  const assistantOptions = parameters?.assistantOptions;

  let createMessageResponse;

  return createMessage(sessionId, {
    body,
    payload,
    attachments,
    lastDeflection,
    isInAssistantMode,
    initAssistantPayload,
    lang,
    assistantOptions,
  })
    .then((res) => {
      createMessageResponse = res;
      const { id } = res.data;

      if (attachments?.length) {
        return delayFetchMessageAttachments(id);
      }
      return undefined;
    })
    .then((attachments) => {
      const attachmentsData = attachments?.data;
      const callbackResponse = createMessageCallbackResponse(
        createMessageResponse.data,
        attachmentsData,
      );

      runListenersForEvent(ON_MESSAGE_SENT_EVENT_TYPE, callbackResponse);

      if (typeof cb === 'function') cb(callbackResponse);
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);

      if (error.status === 423) {
        const endedCallbackResponse: ConversationCallbackResponse = {
          conversationId: sessionId,
          ended: true,
        };

        runListenersForEvent(
          ON_CONVERSATION_ENDED_EVENT_TYPE,
          endedCallbackResponse,
        );
      }

      runListenersForEvent(ON_MESSAGE_SENT_EVENT_TYPE, null, error);
      handleError(error, { message: 'Failed to send message:' });
    });
};
